import { Avatar, AvatarProps } from '@material-ui/core';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { identityKind } from '../../utils';
import { getIdentityKindIcon } from './identityKindIcon';

export type IdentityAvatarMuiProps = Omit<AvatarProps, 'children'> & {
  identityRef?: IdentityRefFragment | null;
};

/** @deprecated Legacy MUI copy - migrate consumers to the Encore IdentityAvatar and delete. */
export const IdentityAvatarBaseMui = (
  props: IdentityAvatarMuiProps & { avatarSrc?: string },
) => {
  const { identityRef, avatarSrc, imgProps, ...avatarProps } = props;

  const kind = identityRef?.name ? identityKind(identityRef.name) : undefined;

  return (
    <Avatar
      {...(kind === 'user' ? { 'data-csr-block': true } : {})}
      {...avatarProps}
      imgProps={{ referrerPolicy: 'no-referrer', ...imgProps }}
      src={avatarSrc}
      title={identityRef?.displayName ?? undefined}
    >
      {getIdentityKindIcon(kind)}
    </Avatar>
  );
};
